import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, Tooltip, Polyline } from 'react-leaflet';
import { Button, Col, Row } from 'reactstrap';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//API
import cep_api from '../../../../../api/cep_api';

//Components
import TextField from '../../../../../components/TextField';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Context
import { useAuth } from '../../../../../context/auth';


function initialStatePlanoTrabalhoLocal(sequencia = 1) {
  return {
    cep: "",
    logradouro: "",
    latitude: "",
    longitude: "",
    sequencia: sequencia,
    excluido: false
  }
}

function MapaPlanoTrabalho({ planoTrabalho, setPlanoTrabalho, editavel }) {
  //State para centralizar o mapa
  const [center, setCenter] = useState([-23.2198396, -45.8915658]);

  //State para pegar o local
  const [localSelecionado, setLocalSelecionado] = useState(null);

  //State para modal
  const [isModal, setIsModal] = useState(false);

  //Função para altenar o modal
  const toggleModal = () => setIsModal(!isModal);

  //Estado de controle dos campos de erro
  const [errors, setErrors] = useState({});

  const { setLoading } = useAuth();

  function AddMarkerToClick({ localSelecionado, setLocalSelecionado, toggleModal }) {
    useMapEvents({
      click(e) {

        let markerUltimo = [];
        if (planoTrabalho?.planoTrabalhoLocais?.length > 0) {
          let ultimo = planoTrabalho.planoTrabalhoLocais.filter(s => s.excluido == false);
          if (ultimo.length > 0) {
            markerUltimo = [ultimo.pop()];
          }
        }

        setLoading(true);
        cep_api.GeoCodeLatLog(e.latlng.lat.toString(), e.latlng.lng.toString()).then(response => {
          setLocalSelecionado({
            ...localSelecionado,
            bairro: response.data.bairro,
            logradouro: response.data.logradouro,
            latitude: e.latlng.lat,
            longitude: e.latlng.lng,
            sequencia: markerUltimo.length > 0 ? markerUltimo[0].sequencia + 1 : 1,
            excluido: false
          });
          toggleModal();
        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
          .finally(() => setLoading(false));
      },
    })

    return <></>
  }

  //Estado de controle dos campos obrigatorios 
  const [campos, setCampos] = useState([
    objCampo({ name: "logradouro", required: true }),
    objCampo({ name: "bairro", required: true }),
  ])

  //Função de onChange dos campos de cadastro
  const onChange = (e) => {
    const { name, value } = e.target;
    const _localSelecionado = {
      ...localSelecionado,
      [name]: value
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === name);
    const fieldError = validarCampos(_localSelecionado, _campos);

    const _errors = { ...errors };
    delete _errors[name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setLocalSelecionado(_localSelecionado);
  }

  const RemoveLocalPlanoTrabalho = () => {
    if (planoTrabalho?.planoTrabalhoLocais?.length > 0) {
      const _planoTrabalhoLocais = planoTrabalho?.planoTrabalhoLocais?.map(value => {
        if (localSelecionado.latitude == value.latitude && localSelecionado.longitude == value.longitude)
          return { ...value, excluido: true };
        else
          return value;
      })
      setPlanoTrabalho({
        ...planoTrabalho,
        planoTrabalhoLocais: [..._planoTrabalhoLocais]
      })
      setLocalSelecionado(initialStatePlanoTrabalhoLocal(_planoTrabalhoLocais?.length > 0 ? _planoTrabalhoLocais.length + 1 : 1));
      toggleModal();
    } else {
      setLocalSelecionado(initialStatePlanoTrabalhoLocal(planoTrabalho?.planoTrabalhoLocais?.length > 0 ? planoTrabalho?.planoTrabalhoLocais?.length + 1 : 1));
      toggleModal();
    }
  }

  const AddLocalPlanoTrabalho = () => {
    const _errors = validarCampos(localSelecionado, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    let _planoTrabalhoLocais = planoTrabalho?.planoTrabalhoLocais;

    if (_planoTrabalhoLocais?.length > 0 && _planoTrabalhoLocais?.some(v => v.latitude == localSelecionado.latitude && localSelecionado.longitude == v.longitude)) {
      _planoTrabalhoLocais = _planoTrabalhoLocais.map((value) => {
        if (value.latitude == localSelecionado.latitude && value.longitude == localSelecionado.longitude) {
          return { ...localSelecionado };
        } else
          return value;
      })
    } else {
      _planoTrabalhoLocais.push(localSelecionado);
    }

    setPlanoTrabalho({ ...planoTrabalho, planoTrabalhoLocais: [..._planoTrabalhoLocais] })
    setLocalSelecionado(initialStatePlanoTrabalhoLocal(_planoTrabalhoLocais?.length > 0 ? _planoTrabalhoLocais.length + 1 : 1))
    toggleModal();
  }


  return (
    <>
      {isModal &&
        <ModalCustomized
          title={"Adicionar local"}
          isOpen={isModal}
          toggle={toggleModal}
          btnClose={toggleModal}
        >
          <Row>
            <Col md="12" lg="4">
              <TextField
                label="* Bairro"
                name={"bairro"}
                onChange={onChange}
                value={localSelecionado.bairro}
                maxLength={150}
                invalid={!!errors.bairro}
                disabled={true}
              />
            </Col>
            <Col md="12" lg="6">
              <TextField
                label="* Logradouro"
                name={"logradouro"}
                onChange={onChange}
                value={localSelecionado.logradouro}
                maxLength={150}
                disabled={true}
              />
            </Col>
            <Col md="12" lg="2  ">
              <TextField
                type={"text"}
                label="* Sequência"
                name={"sequencia"}
                onChange={onChange}
                value={localSelecionado.sequencia}
                maxLength={10}
                invalid={!!errors.sequencia}
                disabled={!editavel}
              />
            </Col>
            <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center gap-2 ${editavel ? "" : "d-none"}`}>
              <Button
                className='px-4'
                color={"danger"}
                onClick={RemoveLocalPlanoTrabalho}>
                <FontAwesomeIcon icon={faEdit} /> Remover
              </Button>
              <Button
                className='px-4'
                color={planoTrabalho?.planoTrabalhoLocais?.some(v => v.latitude == localSelecionado.latitude && localSelecionado.longitude == v.longitude) ? 'warning text-white' : 'success'}
                onClick={AddLocalPlanoTrabalho}>
                {planoTrabalho?.planoTrabalhoLocais?.some(v => v.latitude == localSelecionado.latitude && localSelecionado.longitude == v.longitude) ?
                  <><FontAwesomeIcon icon={faEdit} /> Atualizar</>
                  : "+ Cadastrar"
                }
              </Button>
            </Col>
          </Row>
        </ModalCustomized>
      }

      <div style={{ height: "400px", backgroundColor: "#333", position: "relative" }}>
        <MapContainer
          center={planoTrabalho?.planoTrabalhoLocais.length > 0 ? [planoTrabalho?.planoTrabalhoLocais[0].latitude, planoTrabalho?.planoTrabalhoLocais[0].longitude] : center}
          style={{ height: "100%", width: "100%" }}
          zoom={15}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <AddMarkerToClick
            localSelecionado={localSelecionado}
            setLocalSelecionado={setLocalSelecionado}
            toggleModal={toggleModal}
          />

          {planoTrabalho.planoTrabalhoLocais?.filter(v => !v.excluido)?.map((value, index) => {
            if (value.latitude && value.longitude) {
              return (
                <Marker
                  key={index}
                  position={[value.latitude, value.longitude]}
                  eventHandlers={{
                    click: (e) => {
                      setLocalSelecionado(value);
                      toggleModal();
                    },
                  }}
                >
                  <Tooltip direction='center' className='leaflet-tooltip-green' offset={[0, 0]} opacity={1} permanent>
                    <span>{value.sequencia}</span>
                  </Tooltip>
                </Marker>
              );
            }
          })}
        </MapContainer>
      </div>
    </>
  );
}

export default MapaPlanoTrabalho;
